<template>
  <b-button
    :ref="details.name"
    :style="style"
    :class="{'selected-border': selected}"
    @click="click"
  >
    {{ details.name }}
  </b-button>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import { StoryKeys, TreeNode } from '@/types'

const props = {
  details: {
    type: Object as PropType<TreeNode>,
    required: true,
  },
}

@Component
export default class MapSubTierHeader extends Vue.extend({ props }) {
  get level1 () {
    return this.details.path.level1
  }

  get tabFontColor () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.tabFontColor(this.level1, StoryKeys.SIDEBAR_BOT)
  }

  get style () {
    return {
      'background-color': this.$typedStore.activeVisualisation.visualisationStore.entities.nodes.colour(this.level1),
      color: this.tabFontColor,
    }
  }

  get selected () {
    return this.$typedStore.public.display.storyPath.equals(this.details.path)
  }

  click () {
    this.$typedStore.activeVisualisation.updateStoryPath(this.details.path)
    this.$analytics.event('click', {
      event_category: 'map-sub-tier-header',
      event_label: this.details.path,
    })
  }
}

</script>

<style scoped>

.selected-border {
  border-width: 3px !important;
  border-color: black !important;
}

</style>
